"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalLossDecisionState = void 0;
var TotalLossDecisionState;
(function (TotalLossDecisionState) {
    TotalLossDecisionState["TotalLoss"] = "TOTAL_LOSS";
    TotalLossDecisionState["Repairable"] = "REPAIRABLE";
    TotalLossDecisionState["Review"] = "REVIEW";
})(TotalLossDecisionState = exports.TotalLossDecisionState || (exports.TotalLossDecisionState = {}));
